import { motion } from "framer-motion";
import "./Workforce.css";

import img11 from "./assets/core1.png";
import img22 from "./assets/core2.png";
import img33 from "./assets/core3.png";

const cards = [
  {
    id: "employee-availability",
    img: img11,
    title: "Employee Availability",
    desc:
      "View and adjust your overall employee roster with detail that includes actual shift and leave information along with the cost and scheduled hour information.",
  },
  {
    id: "schedule-template",
    img: img22,
    title: "Schedule Template",
    desc:
      "Plan your schedule pattern ahead of time with multiple schedule templates for various shifts and departments. Publish this template with a single click.",
  },
  {
    id: "schedule-rules",
    img: img33,
    title: "Schedule Creation Rule",
    desc:
      "JIVIEWS ensures that your managers create schedules that meet organizational objectives based on a variety of KPIs and meets the forecasting demands.",
  },
];

const WorkforceCore = () => {
  return (
    <section className="relative w-full font-epilogue overflow-hidden py-[clamp(20px,4vw,50px)] flex justify-center font-poppins">
      <motion.div
        className="workforce-core-bg absolute inset-0 -z-10"
        animate={{
          backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
        }}
        transition={{
          duration: 15,
          ease: "linear",
          repeat: Infinity,
        }}
      />

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="w-full max-w-[1300px] bg-white/80 backdrop-blur-md rounded-[20px] shadow-[0_0_25px_rgba(0,0,0,0.05)] px-[clamp(20px,3vw,50px)] py-[clamp(20px,4vw,50px)] relative z-10"
      >
       
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 mb-[clamp(20px,3vw,40px)]">
          <motion.h2
            initial={{ opacity: 0, x: -80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
            className="text-[#1D1D1D] text-[clamp(24px,2vw,32px)] font-bold leading-snug max-w-[500px]"
          >
            Core Functions of Workforce Scheduler
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: true }}
            className="text-[#333333] text-[clamp(13px,1vw,16px)] max-w-[580px] leading-relaxed"
          >
            The Workforce Scheduler optimizes task allocation and resource
            planning to ensure efficient and timely execution of all operational
            activities.
          </motion.p>
        </div>

       
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[clamp(16px,2.5vw,28px)]">
          {cards.map((card, index) => (
            <motion.div
              key={card.id}
              initial={{ opacity: 0, x: -80 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.6,
                ease: "easeOut",
                delay: index * 0.2,
              }}
              whileHover={{
                scale: 1.03,
                boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
              }}
              className="flex flex-col items-start bg-white rounded-[24px] p-[clamp(20px,2.5vw,32px)] text-left transition-all duration-300"
            >
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, ease: "easeOut", delay: 0.3 }}
                viewport={{ once: true }}
                className="w-full flex justify-center items-center rounded-[20px] p-5 mb-4 relative overflow-hidden"
              >
                <motion.img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-contain transition-transform duration-500"
                  whileHover={{
                    scale: 1.15,
                    rotate: 2,
                    filter:
                      "drop-shadow(0 6px 10px rgba(0, 255, 150, 0.3))",
                  }}
                />
              </motion.div>

              <h3 className="text-[#1D1D1D] font-semibold text-[clamp(17px,1.3vw,19px)] mb-1">
                {card.title}
              </h3>
              <p className="text-[#555] text-[clamp(13px,0.9vw,15px)] leading-relaxed">
                {card.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default WorkforceCore;
